import React from "react";
import { Tooltip } from "@material-ui/core";
import { BlackTooltip } from "./styles";

export default ({ component, ...props }) => {

	return (
		<Tooltip {...props} classes={BlackTooltip()} >
			{component}
		</Tooltip>
	)
};
